<template>
    <v-container class="form-container">
        <p-header title="Questionnaire" />
        <p-detail :ctrl="ctrl" />
        <p-actions :ctrl="ctrl" :section_ctrl="section_ctrl" />
        <p-sections :ctrl="ctrl" :section_ctrl="section_ctrl" />
    </v-container>
</template>

<script>
    import p_header from '../header';
    import p_detail from './components/detail';
    import p_actions from './components/actions';
    import p_sections from './components/sections';

    export default {
        components: {
            'p-header': p_header,
            'p-detail': p_detail,
            'p-actions': p_actions,
            'p-sections': p_sections,
        },
        data() {
            return {
                ctrl: this.get_controller("questionnaire"),
                section_ctrl: this.get_controller("questionnaire_section"),
            };
        },
    };
</script>

<style>
</style>